import React from 'react';
import _ from 'lodash';
import { array, func } from 'prop-types';
import { useTranslation } from 'react-i18next';
import TopDrugs from '../../components/static/TopDrugs.json';

const TopDrugsNew = ({ handleDrugClick = () => {} }) => {
  const { i18n, t } = useTranslation();
  return (
    <section className="top-drugs">
      <article>
        <h2 className="top-drugs-heading desktop-only">{t('Popular')}</h2>
        <h2 className="top-drugs-heading mobile-only">
          {t('Most popular drugs')}
        </h2>
        <ul>
          {!_.isEmpty(TopDrugs.newHomeTopDrugsV2) &&
            TopDrugs.newHomeTopDrugsV2.map((item, id) => {
              return (
                <li key={id}>
                  <a
                    href={`${_.withLocale(i18n.language, '/prescription')}/${
                      item.seoName
                    }`}
                    onClick={e => {
                      handleDrugClick(e, item.seoName);
                    }}
                    className="whiteFocus"
                  >
                    {item.name}
                  </a>
                </li>
              );
            })}
        </ul>
      </article>
    </section>
  );
};

TopDrugsNew.propTypes = {
  drugs: array,
  handleDrugClick: func
};

export default TopDrugsNew;
